import styled from 'styled-components';
import { MuiTextField } from 'theme/material-ui';

export const StyledTextField = styled(MuiTextField)`
  width: 100%;
  & .MuiOutlinedInput-root > input {
    min-height: auto;
  }
`;

export const InitialsTextField = styled(MuiTextField)`
  &&& {
    margin-right: 10px;
  }

  & .MuiOutlinedInput-root > input {
    width: 150px;
    min-height: auto;
  }
`;
